import { AlertDialogBody, AlertDialogFooter } from '@chakra-ui/react'

import {
  Box as DarkBox,
  Button as DarkButton,
  Modal as DarkModal,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { BasicAlertDialog, Button } from '@/components/ui'

interface ExitGridTestingConfirmDialogIProps {
  colorScheme?: ColorScheme
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  zIndex?: number
}

export const ExitGridTestingConfirmDialog = ({
  colorScheme,
  isOpen,
  onCancel,
  onConfirm,
  zIndex = 1100,
}: ExitGridTestingConfirmDialogIProps) => {
  if (colorScheme) {
    return (
      <DarkModal
        colorScheme={colorScheme}
        footer={
          <>
            <DarkButton
              colorScheme={colorScheme}
              onClick={onCancel}
              variant='tertiary'
            >
              Cancel
            </DarkButton>
            <DarkButton
              colorScheme={colorScheme}
              onClick={onConfirm}
              variant='danger'
            >
              Exit Test
            </DarkButton>
          </>
        }
        isOpen={isOpen}
        isSaveHidden
        onClose={onCancel}
        size='compact'
        title='Exit Grid Testing Zone?'
        zIndex={zIndex}
      >
        <DarkBox>
          Your test progress will be lost. Are you sure you want to exit?
        </DarkBox>
      </DarkModal>
    )
  }

  return (
    <BasicAlertDialog
      isCentered
      isOpen={isOpen}
      onClose={onCancel}
      title='Exit Grid Testing Zone?'
    >
      <AlertDialogBody>
        Your test progress will be lost. Are you sure you want to exit?
      </AlertDialogBody>
      <AlertDialogFooter>
        <Button mr={3} onClick={onCancel} variant='secondary'>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant='danger'>
          Exit Test
        </Button>
      </AlertDialogFooter>
    </BasicAlertDialog>
  )
}
